// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const NavButtonTypes = {
  "NEXT": "NEXT",
  "PREVIOUS": "PREVIOUS",
  "CANCEL": "CANCEL",
  "SUBMIT": "SUBMIT",
  "GOTO": "GOTO",
  "DONE": "DONE"
};

const ControlTypes = {
  "AUTHORS": "AUTHORS",
  "AFFILIATIONS": "AFFILIATIONS",
  "CHECKBOX": "CHECKBOX",
  "DATETIME": "DATETIME",
  "FILE": "FILE",
  "INFORMATION": "INFORMATION",
  "MATHS": "MATHS",
  "RADIO": "RADIO",
  "RATING": "RATING",
  "BUTTON": "BUTTON",
  "SLIDER": "SLIDER",
  "SWITCH": "SWITCH",
  "SPONSOR": "SPONSOR",
  "SUBMISSIONLIST": "SUBMISSIONLIST",
  "LANGUAGES": "LANGUAGES",
  "TABLE": "TABLE",
  "TEXT": "TEXT",
  "TOGGLE": "TOGGLE",
  "TOPICADVICE": "TOPICADVICE",
  "SELECT": "SELECT",
  "SUMMARY": "SUMMARY",
  "MESSAGE": "MESSAGE"
};

const FormTypes = {
  "SUBMISSION": "SUBMISSION",
  "REVIEW": "REVIEW",
  "REGISTRATION": "REGISTRATION",
  "APPLICATION": "APPLICATION"
};

const AssetTypes = {
  "REPORT": "REPORT",
  "VIEW": "VIEW",
  "DICTIONARY": "DICTIONARY",
  "REVIEW": "REVIEW",
  "OPTIONS": "OPTIONS",
  "PREVIEW": "PREVIEW",
  "FILE": "FILE"
};

const LinkedFileType = {
  "JSON": "JSON",
  "IMAGE": "IMAGE",
  "PDF": "PDF",
  "HTML": "HTML",
  "UNKNOWN": "UNKNOWN"
};

const EventsSourceType = {
  "USER": "USER",
  "LAMBDA": "LAMBDA",
  "SCHEDULER": "SCHEDULER",
  "SYSTEM": "SYSTEM",
  "AI": "AI",
  "INTEGRATION": "INTEGRATION",
  "QUEUE": "QUEUE",
  "WORKFLOW": "WORKFLOW",
  "ADMIN": "ADMIN"
};

const LogCategory = {
  "LOGIN": "LOGIN",
  "LOGOUT": "LOGOUT",
  "CREATED": "CREATED",
  "UPDATED": "UPDATED",
  "DELETED": "DELETED",
  "CLONED": "CLONED",
  "UNKNOWN": "UNKNOWN",
  "INITIALISE": "INITIALISE",
  "COMMENT_ADDED": "COMMENT_ADDED",
  "FILE_UPLOADED": "FILE_UPLOADED",
  "PERMISSIONS_UPDATED": "PERMISSIONS_UPDATED",
  "REVIEW_ASSIGNED": "REVIEW_ASSIGNED",
  "AI_REVIEW_GENERATED": "AI_REVIEW_GENERATED",
  "AI_SUGGESTION": "AI_SUGGESTION",
  "AI_ERROR": "AI_ERROR",
  "APPROVAL_CHECK": "APPROVAL_CHECK",
  "SEND": "SEND",
  "RESET": "RESET",
  "EMAIL_SENT": "EMAIL_SENT"
};

const LogType = {
  "ERROR": "ERROR",
  "WARNING": "WARNING",
  "INFO": "INFO",
  "COMPLETE": "COMPLETE"
};

const ModelType = {
  "USER": "USER",
  "PROJECT": "PROJECT",
  "SUBMISSION": "SUBMISSION",
  "REVIEW": "REVIEW",
  "FORM": "FORM",
  "EVENT": "EVENT",
  "LOG": "LOG",
  "ASSET": "ASSET",
  "ACCOUNT": "ACCOUNT",
  "UNKNOWN": "UNKNOWN"
};

const { Accounts, Projects, Assets, Submissions, Forms, Users, Tokens, Counters, Events, Logs, AnalysisResult, StreamChunk, Files, Rules, Policies, UserForms, NavButtons, Flags, Controls, Pages, LinkedObject, SubmissionMetadata, Dictionary, TeamMember } = initSchema(schema);

export {
  Accounts,
  Projects,
  Assets,
  Submissions,
  Forms,
  Users,
  Tokens,
  Counters,
  Events,
  Logs,
  NavButtonTypes,
  ControlTypes,
  FormTypes,
  AssetTypes,
  LinkedFileType,
  EventsSourceType,
  LogCategory,
  LogType,
  ModelType,
  AnalysisResult,
  StreamChunk,
  Files,
  Rules,
  Policies,
  UserForms,
  NavButtons,
  Flags,
  Controls,
  Pages,
  LinkedObject,
  SubmissionMetadata,
  Dictionary,
  TeamMember
};